import React from 'react';

import { Settings } from 'screens/shared';

import DieselTransOil from './DieselTransOil/DieselTransOil';
import DieselEngineOil from './DieselEngineOil/DieselEngineOil';
import GearboxOil from './GearboxOil/GearboxOil';

const DieselSettings = () => {
  const components = {
    transOil: {
      name: DieselTransOil,
      route: 'trans-oil',
      actions: ['resetValue']
    },
    engineOil: {
      name: DieselEngineOil,
      route: 'engine-oil',
      actions: ['resetValue']
    },
    gearboxOil: {
      name: GearboxOil,
      route: 'gearbox-oil',
      actions: ['resetValue']
    }
  };

  return <Settings components={components} />;
};

export default DieselSettings;



// WEBPACK FOOTER //
// ./src/screens/Diesel/DieselSettings/DieselSettings.js